import React, { useEffect } from "react";
import './fonts.css'
import ReactGA from 'react-ga4';

const Home = () => {
    useEffect(() => {
        // Track when Home component mounts
        ReactGA.event({
            category: "Page View",
            action: "Home Page View",
            label: "Home Component Mount"
        });
    }, []);

    return (
        <>
            <div className="relative text-center">
                <h1 className="text-2xl font-semibold" style={{ fontFamily: "'Segoe UI', sans-serif" }}>Abdul Alhusaini</h1>
                <p className="absolute left-0 right-0 top-full mt-1 text-m" style={{ fontFamily: "'Segoe UI', sans-serif" }}>abdulgo@aol.com</p>
            </div>
        </>
    )
}

export default Home
